import Navbar from "../../components/navbar/navbar";
import Footer from "../../components/footer/footer";
import {
  Formik,
  Field,
  Form,
  FormikHelpers,
  FieldProps,
  ErrorMessage,
  FormikProps,
} from "formik";
import { FiInfo, FiAlertTriangle } from "react-icons/fi";
import CoordinateInput from "@/components/CoordinateInput";
import SimpleFileUpload from "../../components/upload/SimpleFileUpdate";
import colors from "../../utils/colors";

import {
  Button,
  Center,
  Container,
  FileListContainer,
  Input,
  InputContainer,
  InputError,
  InputLabel,
  Main,
  Select,
  Title,
  Textarea,
} from "./style";
import { toast, ToastContainer } from "react-toastify";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { useServiceProperty } from "../../hooks/serviceProperty";
import { useNavigate } from "react-router-dom";
import FileUploadSquare from "../../components/upload/fileUploadSquare";
import { useServiceHome } from "../../hooks/serviceHome";
import { PropertyLocationSelector } from "../../components/location-selector/property-location-selector";
import { useAuth } from "@/context/AuthContext";

export default function RegisterProperty() {
  const { createProperty, generateContractPreview } = useServiceProperty();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [files, setFiles] = useState({
    file_deed_number: "",
    file_cib: "",
    file_proof_of_residence: "",
    file_images: "",
    file_updated_property_registration: "",
    file_encumbrance_certificate: "",
    file_power_of_attorney: "",
    file_itr_debt_clearance_certificate: "",
    file_thirty_years_certificate: "",
    file_ibama_negative_certificate: "",
  });
  const [buttonSave, setButtonSave] = useState(t("save"));
  const { getVegetations } = useServiceHome();
  const { user } = useAuth();
  const [vegetations, setVegetations] = useState<any[]>([]);
  const [clearFilesUpload, setClearFilesUpload] = useState(false);
  const [catalog, setCatalog] = useState("sell");
  const [latitude, setLatitude] = useState(""); // Estado local para latitude
  const [longitude, setLongitude] = useState("");
  const [contractHtml, setContractHtml] = useState<string | null>(null);
  const [showContractModal, setShowContractModal] = useState(false);
  const [emptyFiles, setEmptyFiles] = useState({
    file_cib: false,
    file_deed_number: false,
    file_proof_of_residence: false,
  });

  useEffect(() => {
    async function getVegetationsAll() {
      await getVegetations()
        .then((response: any) => {
          setVegetations(response);
        })
        .catch((error) => {
          console.log(error);
        });
    }

    getVegetationsAll();
  }, []);

  const initialValues = {
    catalogs: "sell",
    name: "",
    deed_number: "",
    acre: "",
    preserved_area: "",
    cib_nirf_number: "",
    cost: "",
    description: "",
    vegetation: "dense",
    address: "",
    lat: "",
    lng: "",
    carbon_credits: "",
  };

  const handleLatitudeChange = (value: string) => {
    setLatitude(value); // Atualiza o valor de latitude
  };

  const handleLongitudeChange = (value: string) => {
    console.log("VALOR FINAL:", value);
    setLongitude(value); // Atualiza o valor de longitude
  };

  const convertDMSToDecimal = (dms: string): number => {
    // const [degrees, minutes, seconds, direction] =
    //   dms.match(/(\d+)[° ](\d+)'(\d+)?''? ([NSEW])/i)?.slice(1) || [];

    const regex = /^(\d{1,3})°(\d{1,2})'(\d{1,2}(?:\.\d+)?)"\s*([NSEW])$/i;
    const match = dms.match(regex);

    if (!match) {
      throw new Error("Formato inválido.");
    }

    const [, degreesStr, minutesStr, secondsStr, direction] = match;

    const degrees = parseFloat(degreesStr);
    const minutes = parseFloat(minutesStr);
    const seconds = parseFloat(secondsStr);

    if (
      degrees < 0 ||
      degrees > 180 ||
      minutes < 0 ||
      minutes >= 60 ||
      seconds < 0 ||
      seconds >= 60
    ) {
      throw new Error("Valores fora do intervalo válido em DMS.");
    }

    const decimal = degrees + minutes / 60 + seconds / 3600;
    return direction === "S" || direction === "W" ? -decimal : decimal;

    // if (!degrees || !minutes || !direction) {
    //   throw new Error("Formato inválido");
    // }

    // const decimal =
    //   parseFloat(degrees) +
    //   parseFloat(minutes) / 60 +
    //   parseFloat(seconds || "0") / 3600;

    // // Ajusta o sinal para o hemisfério
    // return direction === "S" || direction === "W" ? -decimal : decimal;
  };

  const formValidation = (values: typeof initialValues) => {};

  const handleSubmit = async (
    values: typeof initialValues,
    actions: FormikHelpers<typeof initialValues>
  ) => {
    setButtonSave(`${t("waiting")}...`);
    values.catalogs = catalog;
    // Tente converter latitude e longitude no formato DMS para decimal
    let latDecimal = latitude; // Valor inicial em DD
    let lngDecimal = longitude; // Valor inicial em DD

    try {
      // Tente converter a latitude de DMS para decimal
      latDecimal = convertDMSToDecimal(latitude).toString();
      lngDecimal = convertDMSToDecimal(longitude).toString();
    } catch (error) {
      console.warn(
        "Latitude não pôde ser convertida; mantendo o formato existente.",
        error
      );
    }

    values.cost = "0";
    values.carbon_credits = "0";

    const reqFiles = requiredFiles();

    if (catalog === "sell" && reqFiles) {
      await createProperty({
        ...values,
        ...files,
        lat: latDecimal,
        lng: lngDecimal,
      } as any)
        .then((response: any) => {
          toast.warning(t("property-analysis"), {
            position: "top-center",
          });
          setTimeout(() => {
            navigate("/mySpace");
          }, 4000);
          setClearFilesUpload(true);
        })
        .finally(() => {
          setButtonSave(`${t("save")}`);
        });
    } else if (catalog === "sell" && !reqFiles) {
      toast.warning(t("required-files"), {
        position: "top-center",
      });
      let aux = emptyFiles;
      aux["file_cib"] = files.file_cib == "" ? true : false;
      aux["file_deed_number"] = files.file_deed_number == "" ? true : false;
      aux["file_proof_of_residence"] =
        files.file_proof_of_residence == "" ? true : false;
      setEmptyFiles({ ...aux });
      setButtonSave(`${t("save")}`);
    } else if (catalog === "catalog") {
      await createProperty({
        ...values,
        ...files,
        lat: latDecimal,
        lng: lngDecimal,
      } as any)
        .then((response: any) => {
          toast.success(t("successfully"), {
            position: "top-center",
          });

          setTimeout(() => {
            navigate("/mySpace");
          }, 4000);

          setClearFilesUpload(true);
        })
        .finally(() => {
          setButtonSave(`${t("save")}`);
        });
    }
  };

  const requiredFiles = () => {
    if (
      files.file_cib != "" &&
      files.file_deed_number != "" &&
      files.file_proof_of_residence != ""
    ) {
      return true;
    }
    return false;
  };

  const onFileSelected = (name: string, index?: number) => (file: string) => {
    setFiles((prevFiles) => ({ ...prevFiles, [name]: file }));

    if (index == undefined) return;

    let aux = emptyFiles;
    if (index == 0) {
      aux.file_cib = false;
    } else if (index == 1) {
      aux.file_deed_number = false;
    } else if (index == 2) {
      aux.file_proof_of_residence = false;
    }

    setEmptyFiles({ ...aux });
  };

  const fieldsFilled = (values: typeof initialValues) => {
    return (
      values.name.trim().length > 0 &&
      values.acre.trim().length > 0 &&
      values.preserved_area.trim().length > 0 && 
      values.cib_nirf_number.trim().length > 0 &&
      values.lat.trim().length > 0 &&
      values.lng.trim().length > 0 &&
      values.vegetation.trim().length > 0 &&
      values.deed_number.trim().length > 0 &&
      values.description.trim().length > 0 &&
      files.file_cib !== "" &&
      files.file_deed_number !== "" &&
      files.file_proof_of_residence !== ""
    );
  };

  return (
    <Container>
      <ToastContainer />
      <Main>
        <Title>{t("register-property")}</Title>
        <div className="bg-amber-200 !border !border-amber-500 rounded-2xl p-4 mb-4 flex items-center gap-4 justify-center">
          <FiAlertTriangle size={24} />
          <p className="font-semibold text-center">{t("contract_view")}</p>
        </div>
        <Formik
          validate={formValidation}
          initialValues={initialValues}
          onSubmit={handleSubmit}
        >
          {({ values }) => (
            <Form>
              <InputContainer>
                <div
                  style={{
                    width: "100%",
                    borderBottom: "1px solid #eee",
                    paddingBottom: "30px",
                    marginBottom: "30px",
                  }}
                >
                  <InputLabel>{t("how_register")}</InputLabel>
                  <Field
                    as={Select}
                    type="text"
                    name="catalog"
                    required
                    onChange={(event: any) => {
                      const value = event.target.value;
                      setCatalog(value);
                    }}
                  >
                    <option key={"sell"} value={"sell"}>
                      {t("i-seller")}
                    </option>
                    <option key={"catalog"} value={"catalog"}>
                      {t("i-catalog")}
                    </option>
                  </Field>
                </div>
              </InputContainer>
              <InputContainer>
                <div
                  style={{
                    width: "100%",
                    paddingBottom: "30px",
                    marginBottom: "30px",
                  }}
                >
                  <InputLabel>
                    {t("name")}
                    <span className="text-red-600">*</span>
                  </InputLabel>
                  <Field
                    // as={Input}
                    // type="text"
                    name="name"
                    validate={(value: string) => {
                      let errorMessage;
                      if (value.length == 0) {
                        return (errorMessage = t("required"));
                      }
                      if (value.length < 6) {
                        return (errorMessage = t("min_6"));
                      }
                    }}
                    required
                    minLength={6}
                    // style={{
                    //   width: "100%",
                    //   padding: "10px",
                    //   borderRadius: "5px",
                    //   border: "1px solid #ccc",
                    // }}
                    style={{ marginBottom: "20px" }}
                  >
                    {({ field, form, meta }: FieldProps) => (
                      <div>
                        <input
                          type="text"
                          {...field}
                          style={{
                            border: `1px solid ${
                              meta.touched && meta.error ? "red" : "#ccc"
                            }`,
                            borderRadius: "5px",
                            width: "100%",
                            padding: "10px",
                            color: "#8F8F8F",
                            marginBottom: `${
                              meta.touched && meta.error ? "0px" : "10px"
                            }`,
                          }}
                        />
                        {meta.touched && meta.error && (
                          <div
                            className="error"
                            style={{
                              color: "red",
                              fontSize: "14px",
                              marginBottom: "10px",
                            }}
                          >
                            {t(meta.error)}
                          </div>
                        )}
                      </div>
                    )}
                  </Field>
                  {/* <InputError>
                  <ErrorMessage name="name" />
                </InputError> */}

                  <InputLabel>
                    {t("hectares")}
                    <span className="text-red-600">*</span>
                  </InputLabel>
                  <Field
                    // as={Input}
                    // type="text"
                    name="acre"
                    validate={(value: string) => {
                      let errorMessage;
                      if (value.length == 0) {
                        return (errorMessage = t("required"));
                      }
                    }}
                    required
                    // style={{
                    //   width: "100%",
                    //   padding: "10px",
                    //   borderRadius: "5px",
                    //   border: "1px solid #ccc",
                    // }}
                  >
                    {({ field, form, meta }: FieldProps) => (
                      <div>
                        <input
                          type="text"
                          {...field}
                          style={{
                            border: `1px solid ${
                              meta.touched && meta.error ? "red" : "#ccc"
                            }`,
                            borderRadius: "5px",
                            width: "100%",
                            padding: "10px",
                            color: "#8F8F8F",
                            marginBottom: `${
                              meta.touched && meta.error ? "0px" : "10px"
                            }`,
                          }}
                        />
                        {meta.touched && meta.error && (
                          <div
                            className="error"
                            style={{
                              color: "red",
                              fontSize: "14px",
                              marginBottom: "10px",
                            }}
                          >
                            {t(meta.error)}
                          </div>
                        )}
                      </div>
                    )}
                  </Field>
                  {/* <InputError>
                  <ErrorMessage name="acre" />
                </InputError> */}

                  <InputLabel>
                    {t("preserved_acres")}
                    <span className="text-red-600">*</span>
                  </InputLabel>
                  <Field
                    // as={Input}
                    // type="text"
                    name="preserved_area"
                    validate={(value: string) => {
                      let errorMessage;
                      if (value.length == 0) {
                        return (errorMessage = t("required"));
                      }
                    }}
                    required
                    // style={{
                    //   width: "100%",
                    //   padding: "10px",
                    //   borderRadius: "5px",
                    //   border: "1px solid #ccc",
                    // }}
                  >
                    {({ field, form, meta }: FieldProps) => (
                      <div>
                        <input
                          type="text"
                          {...field}
                          style={{
                            border: `1px solid ${
                              meta.touched && meta.error ? "red" : "#ccc"
                            }`,
                            borderRadius: "5px",
                            width: "100%",
                            padding: "10px",
                            color: "#8F8F8F",
                            marginBottom: `${
                              meta.touched && meta.error ? "0px" : "10px"
                            }`,
                          }}
                        />
                        {meta.touched && meta.error && (
                          <div
                            className="error"
                            style={{
                              color: "red",
                              fontSize: "14px",
                              marginBottom: "10px",
                            }}
                          >
                            {t(meta.error)}
                          </div>
                        )}
                      </div>
                    )}
                  </Field>
                  {/* <InputError>
                  <ErrorMessage name="acre" />
                </InputError> */}

                  <InputLabel>
                    {t("Latitude")}
                    <span className="text-red-600">*</span>
                  </InputLabel>
                  <Field
                    name="lat"
                    onChange={handleLatitudeChange}
                    validate={(value: string) => {
                      if (!value || value.trim().length === 0) {
                        return t("required");
                      }
                    }}
                    required
                  >
                    {({ field, form, meta }: FieldProps) => (
                      <CoordinateInput
                        name={field.name}
                        value={latitude}
                        placeholder="Ex: 12°34'56'' N"
                        meta={meta}
                        setFieldValue={form.setFieldValue}
                        onChange={handleLatitudeChange}
                      />
                    )}
                  </Field>

                  {/* <InputError>
                  <ErrorMessage name="lat" />
                </InputError> */}

                  <InputLabel>
                    {t("Longitude")}
                    <span className="text-red-600">*</span>
                  </InputLabel>
                  <Field
                    name="lng"
                    required
                    validate={(value: string) => {
                      if (!value || value.trim().length === 0) {
                        return t("required");
                      }
                    }}
                    onChange={handleLongitudeChange}
                  >
                    {({ field, form, meta }: FieldProps) => (
                      <CoordinateInput
                        {...field}
                        name={field.name}
                        value={longitude}
                        onChange={handleLongitudeChange}
                        meta={meta}
                        setFieldValue={form.setFieldValue}
                        placeholder="Ex: 123°45'67'' W"
                      />
                    )}
                  </Field>
                  {/* <InputError>
                  <ErrorMessage name="lng" />
                </InputError> */}
                </div>

                <div
                  style={{
                    width: "100%",
                    paddingBottom: "30px",
                    marginBottom: "30px",
                  }}
                >
                  <PropertyLocationSelector />
                  {/*<InputLabel>
                    {t("vegetation")}
                    <span className="text-red-600">*</span>
                  </InputLabel>
                  <Field
                    as={Select}
                    type="text"
                    name="vegetation"
                    required
                    style={{
                      width: "100%",
                      padding: "10px",
                      borderRadius: "5px",
                      border: "1px solid #ccc",
                    }}
                  >
                    {vegetations.map((v) => (
                      <option key={v.slug} value={v.slug}>
                        {t(`vegetation-${v.slug}`)}
                      </option>
                    ))}
                  </Field>
                  <InputError>
                    <ErrorMessage name="vegetation" />
                  </InputError>*/}
                  <InputLabel>
                    {t("deed-number")}
                    <span className="text-red-600">*</span>
                  </InputLabel>
                  <Field
                    // as={Input}
                    // type="text"
                    name="deed_number"
                    disabled={catalog === "catalog"}
                    validate={(value: string) => {
                      let errorMessage;
                      if (value.length == 0) {
                        return (errorMessage = t("required"));
                      }
                    }}
                    required
                    minLength={6}
                    // style={{
                    //   width: "100%",
                    //   padding: "10px",
                    //   borderRadius: "5px",
                    //   border: "1px solid #ccc",
                    // }}
                  >
                    {({ field, form, meta }: FieldProps) => (
                      <div>
                        <input
                          type="text"
                          {...field}
                          style={{
                            border: `1px solid ${
                              meta.touched && meta.error ? "red" : "#ccc"
                            }`,
                            borderRadius: "5px",
                            width: "100%",
                            padding: "10px",
                            color: "#8F8F8F",
                            marginBottom: `${
                              meta.touched && meta.error ? "0px" : "10px"
                            }`,
                          }}
                        />
                        {meta.touched && meta.error && (
                          <div
                            className="error"
                            style={{
                              color: "red",
                              fontSize: "14px",
                              marginBottom: "10px",
                            }}
                          >
                            {t(meta.error)}
                          </div>
                        )}
                      </div>
                    )}
                  </Field>
                  {/* <InputError>
                  <ErrorMessage name="deed_number" />
                </InputError> */}

                  <InputLabel>
                    {t("number-doc")}
                    <span className="text-red-600">*</span>
                  </InputLabel>
                  <Field
                    // as={Input}
                    // type="text"
                    name="cib_nirf_number"
                    validate={(value: string) => {
                      let errorMessage;
                      if (value.length == 0) {
                        return (errorMessage = t("required"));
                      }
                    }}
                    /*required={catalog === "sell"}*/
                    //disabled={catalog === "catalog"}
                    required
                    // style={{
                    //   width: "100%",
                    //   padding: "10px",
                    //   borderRadius: "5px",
                    //   border: "1px solid #ccc",
                    // }}
                  >
                    {({ field, form, meta }: FieldProps) => (
                      <div>
                        <input
                          type="text"
                          {...field}
                          style={{
                            border: `1px solid ${
                              meta.touched && meta.error ? "red" : "#ccc"
                            }`,
                            borderRadius: "5px",
                            width: "100%",
                            padding: "10px",
                            color: "#8F8F8F",
                            marginBottom: `${
                              meta.touched && meta.error ? "0px" : "10px"
                            }`,
                          }}
                        />
                        {meta.touched && meta.error && (
                          <div
                            className="error"
                            style={{
                              color: "red",
                              fontSize: "14px",
                              marginBottom: "10px",
                            }}
                          >
                            {t(meta.error)}
                          </div>
                        )}
                      </div>
                    )}
                  </Field>
                  {/* <InputError>
                  <ErrorMessage name="cib_nirf_number" />
                </InputError> */}
                </div>
              </InputContainer>
              <InputContainer>
                <div style={{ height: "auto" }}>
                  <InputLabel>
                    {t("description")}
                    <span className="text-red-600">*</span>
                  </InputLabel>
                  <Field
                    as={Textarea}
                    name="description"
                    validate={(value: string) => {
                      let errorMessage;
                      if (value.length == 0) {
                        return (errorMessage = t("required"));
                      }
                    }}
                  >
                    {({ field, form, meta }: FieldProps) => (
                      <div>
                        <textarea
                          {...field}
                          style={{
                            border: `1px solid ${
                              meta.touched && meta.error ? "red" : colors.black
                            }`,
                            borderRadius: "4px",
                            width: "100%",
                            padding: "10px",
                            paddingTop: "6px",
                            paddingBottom: "6px",
                            color: `${colors.gray}`,
                            minHeight: "200px",
                          }}
                        />
                        {meta.touched && meta.error && (
                          <div
                            className="error"
                            style={{
                              color: "red",
                              fontSize: "14px",
                              marginBottom: "10px",
                            }}
                          >
                            {t(meta.error)}
                          </div>
                        )}
                      </div>
                    )}
                  </Field>
                  {/*<InputError>
                  <ErrorMessage name="description" />
                </InputError>*/}
                </div>
              </InputContainer>

              <InputContainer>
                <div>
                  <div className="relative flex items-center gap-2 group mt-10">
                    <InputLabel>
                      {t("file")}
                      <span className="text-red-600">*</span>
                    </InputLabel>
                    <FiInfo className="text-gray-500 cursor-pointer" />

                    <div className=" w-1/3 absolute left-1/14 ml-2 top-1/2 -translate-y-1/2 z-10 hidden group-hover:block px-3 py-2 text-sm text-white bg-gray-900 rounded shadow-md">
                      Arquivos marcados com <strong>*</strong> são{" "}
                      <strong>obrigatórios</strong>
                      <div className="absolute left-0 top-1/2 -translate-y-1/2 -ml-1 w-2 h-2 bg-gray-900 rotate-45"></div>
                    </div>
                  </div>
                  <FileListContainer>
                    <>
                      <SimpleFileUpload
                        title="CCIR*"
                        onFileSelected={onFileSelected("file_cib", 0)}
                        clearFiles={clearFilesUpload}
                        empty={emptyFiles.file_cib}
                      />
                      <SimpleFileUpload
                        title={`${t("proof-residence")}*`}
                        onFileSelected={onFileSelected(
                          "file_proof_of_residence",
                          2
                        )}
                        clearFiles={clearFilesUpload}
                        empty={emptyFiles.file_proof_of_residence}
                      />
                      <SimpleFileUpload
                        title={`${t("deed-file")}*`}
                        onFileSelected={onFileSelected("file_deed_number", 1)}
                        clearFiles={clearFilesUpload}
                        empty={emptyFiles.file_deed_number}
                      />
                      <SimpleFileUpload
                        title={t("image-property")}
                        multiple={true}
                        onFileSelected={onFileSelected("file_images")}
                        clearFiles={clearFilesUpload}
                      />
                      <SimpleFileUpload
                        title={t("file_current_registration")}
                        onFileSelected={onFileSelected(
                          "updated_property_registration"
                        )}
                        clearFiles={clearFilesUpload}
                      />
                      <SimpleFileUpload
                        title={t("file_certificate_liens")}
                        onFileSelected={onFileSelected(
                          "encumbrance_certificate"
                        )}
                        clearFiles={clearFilesUpload}
                      />
                      <SimpleFileUpload
                        title={t("file_power_of_attorney")}
                        onFileSelected={onFileSelected("power_of_attorney")}
                        clearFiles={clearFilesUpload}
                      />
                      <SimpleFileUpload
                        title={t("file_itr_certificate")}
                        onFileSelected={onFileSelected(
                          "itr_debt_clearance_certificate"
                        )}
                        clearFiles={clearFilesUpload}
                      />
                      <SimpleFileUpload
                        title={t("file_thirty_years_certificate")}
                        onFileSelected={onFileSelected(
                          "thirty_years_certificate"
                        )}
                        clearFiles={clearFilesUpload}
                      />
                      <SimpleFileUpload
                        title={t("file_ibama_certificate")}
                        onFileSelected={onFileSelected(
                          "ibama_negative_certificate"
                        )}
                        clearFiles={clearFilesUpload}
                      />
                    </>
                  </FileListContainer>
                </div>
              </InputContainer>
              <Center>
                {fieldsFilled(values) && (
                  <Button
                    type="button"
                    style={{ backgroundColor: "green", marginRight: "10px" }}
                    onClick={() => {
                      const contractHtml = generateContractPreview({
                        numeroContrato: "TEMP-0001",
                        fullname: user?.fullname || "",
                        document: user?.document || "",
                        natural: user?.address || "",
                        address: values.address,
                        propertyName: values.name,
                      });

                      setContractHtml(contractHtml);
                      setShowContractModal(true);
                    }}
                  >
                    {t("see_contract")}
                  </Button>
                )}
                <Button type="submit">{buttonSave}</Button>
              </Center>
            </Form>
          )}
        </Formik>
      </Main>
      {showContractModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            backgroundColor: "rgba(0,0,0,0.5)",
            zIndex: 1000,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              backgroundColor: "#fff",
              padding: "30px",
              borderRadius: "10px",
              maxWidth: "80%",
              maxHeight: "80%",
              overflowY: "auto",
            }}
          >
            <button
              onClick={() => setShowContractModal(false)}
              style={{
                position: "absolute",
                top: 20,
                right: 30,
                backgroundColor: "red",
                color: "#fff",
                border: "none",
                padding: "5px 10px",
                borderRadius: "5px",
                cursor: "pointer",
              }}
            >
              Fechar
            </button>
            <div dangerouslySetInnerHTML={{ __html: contractHtml || "" }} />
          </div>
        </div>
      )}

      <Footer />
    </Container>
  );
}
